import axios from 'axios';
import URLS from '../../util/urls.js';

const state = {
  listaSubGrupoConta: [],
  subGrupoPlanoContaPesquisa: {
    nome: undefined,
    pagina: 0
  },
  labelQuantidade: '',
  subGrupoPlanoContaSelecionado: {
    id: 0,
    nome: ''
  },
  gruposDisponiveis: []
}

const mutations = {
  atualizarListaPlanosConta(state, payload) {
    if(state.subGrupoPlanoContaPesquisa.pagina === 0) {
      state.listaSubGrupoConta = payload.lista;
    } else {
      state.listaSubGrupoConta.push(...payload.lista);
    }

    state.labelQuantidade = payload.quantidade + (payload.quantidade == 1 ? " subgrupo encontrado" : " subgrupos encontrados");
  },

  limparSubGrupoContaListadas(state) {
    state.listaSubGrupoConta = [];
  },

  limparSubGrupoContaPesquisa(state) {
    state.subGrupoPlanoContaPesquisa = {
      nome: undefined,
      pagina: 0
    };
  },

  atualizarSubGrupoContaSelecionado(state, payload) {
    state.subGrupoPlanoContaSelecionado = payload
    state.gruposDisponiveis = [payload.grupoPai];
  },

  novoSubGrupoConta(state) {
    state.subGrupoPlanoContaSelecionado = {
      id: 0,
      nome: ''
    },
    state.gruposDisponiveis = [];
  },

  atualizarGruposDisponiveis(state, payload) {
    state.gruposDisponiveis = payload;
  }
}

const actions = {
  limparSubGrupoContaListadas(context) {
    context.commit('limparSubGrupoContaListadas')
  },

  novoSubGrupoConta(context) {
    context.commit('novoSubGrupoConta')
  },

  limparSubGrupoContaPesquisa(context) {
    context.commit('limparSubGrupoContaPesquisa');
  },

  listarSubGrupoConta(context, payload) {
    return axios.post(URLS.SUB_GRUPO_LISTAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit('atualizarListaPlanosConta', response.data);
          return response.data;     
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, {root: true})
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('listarSubGrupoConta', payload)
            }
          }).catch((error) => {
            throw error
          });
        default: 
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  recuperarSubGrupoConta(context, payload) {
    return axios.post(URLS.SUB_GRUPO_RECUPERAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SUCESSO':
          context.commit('atualizarSubGrupoContaSelecionado', response.data.item);
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('recuperarSubGrupoConta', payload)
            }
          }).catch(error => {
            throw error
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  listarGrupos(context, payload) {
    return axios.post(URLS.GRUPO_PLANO_CONTA_LISTAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit('atualizarGruposDisponiveis', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('listarGrupos', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  gravarSubGrupoConta(context, payload) {
    return axios.post(URLS.SUB_GRUPO_GRAVAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SUCESSO':
          context.commit('atualizarSubGrupoContaSelecionado', response.data.item)
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('gravarSubGrupoConta', payload);
            }
          }).catch(error => {
            throw error
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  removerSubGrupoConta(context, payload) {
    return axios.post(URLS.SUB_GRUPO_REMOVER, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SUCESSO':
          context.commit('novoSubGrupoConta');
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', payload)
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('removerSubGrupoConta', payload)
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      } 
    }).catch(error => {
      throw error
    });
  }
}
 
export default {
    state,
    mutations,
    actions,
}